import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Summary_Ten_Scale({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Calculate which scale position (1-10) the score falls into
  // Score is 0-100, so divide by 10 and round up
  const scalePosition = Math.ceil(elementScore / 10) || 1; // Ensure minimum value of 1

  // Generate the 10 scale boxes
  const renderScaleBoxes = () => {
    const boxes = [];
    for (let i = 1; i <= 10; i++) {
      const isActive = i === scalePosition;
      const borderColor = rgbEnabled ? colors.primary : "#4a90e2";

      boxes.push(
        <div
          key={i}
          style={{
            width: "47px",
            height: "40px",
            borderTop: `2px solid ${borderColor}`,
            borderBottom: `2px solid ${borderColor}`,
            borderLeft: i === 1 ? `2px solid ${borderColor}` : "none",
            borderRight: `2px solid ${borderColor}`,
            backgroundColor: isActive ? (rgbEnabled ? colors.primary : "#4a90e2") : "#ffffff",
            color: isActive ? "#ffffff" : rgbEnabled ? colors.dark : "#333333",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "600",
            borderTopLeftRadius: i === 1 ? "6px" : "0",
            borderBottomLeftRadius: i === 1 ? "6px" : "0",
            borderTopRightRadius: i === 10 ? "6px" : "0",
            borderBottomRightRadius: i === 10 ? "6px" : "0",
          }}
        >
          {i}
        </div>
      );
    }
    return boxes;
  };

  return (
    <Row style={{ height: Number(item.height), marginBottom: "2px" }}>
      {/* Item name above the scale */}
      <Col xs="3" className="d-flex justify-content-start ps-3">
        <div
          style={{
            fontSize: isSub ? "13px" : "14px",
            fontWeight: "600",
            color: rgbEnabled ? (!isSub ? colors.dark : colors.primary) : "#333",
            textTransform: "uppercase",
            textAlign: "left",
          }}
        >
          {item.name}
        </div>
      </Col>

      <Col xs="9">
        <div style={{ display: "flex", flexDirection: "row", float: "right" }}>{renderScaleBoxes()}</div>
      </Col>
    </Row>
  );
}
